import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/Logo-Dev-Portfolio.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/icons8-github2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/*<MailchimpForm /> */}

          <Col xs={12} sm={6} className="footer-logo-col">
            <img src={logo} alt="Logo" className="footer-logo" />
          </Col>
          <Col
            xs={12}
            sm={6}
            className="footer-meta-col text-center text-sm-end"
          >
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/luca-liam-spie%C3%9Fl-sch%C3%A4fer-3b0751224/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                <img src={navIcon1} alt="" />
              </a>
              <a
                href="https://github.com/LiamSchaefer"
                target="_blank"
                rel="noreferrer"
                aria-label="GitHub"
              >
                <img src={navIcon2} alt="" style={{ width: "70%" }} />
              </a>
              <a
                href="https://www.instagram.com/luca_liam.photography/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <img src={navIcon3} alt="" />
              </a>
            </div>
            <p>
              {`Copyright Luca Schäfer ${new Date().getFullYear()}. All Rights Reserved`}
              <br />
              Development: Luca Schäfer
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
